<template>
  <div class="Reports__View">
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>ניהול הגדרות ומשובים בקורס {{ course.name }}</template>
      <template #button>
        <a @click="addLecturesFeedbackStatement" class="link-button">
          הוספת היגד
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import CoursesService from "@/services/CoursesService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import LecturesFeedbackStatementEntity from "@/views/LecturesFeedbackStatementEntity.vue";
import DialogAddLecturesFeedbackStatement from '@/components/DialogAddLecturesFeedbackStatement.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";
import { saveAs } from "file-saver";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    course() {
      return this.$store.state.auth.course;
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const lessonsFields = FieldService.list("lecturesFeedbackStatements");

      const sideViewEntity = {
        component: LecturesFeedbackStatementEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי היגד",
        recordUrl: "books",
        recordTitle: "הצג ספר",
        hideRecord: true
      };
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.Name, checked: true },
        { ...lessonsFields.Description, checked: true },
        { ...lessonsFields.TypeName, checked: true },
        { ...lessonsFields.Status, checked: true },
        { ...lessonsFields.SortOrder, checked: true },
      ];

      this.tabs = [
        {
          id: "AllLecturesFeedbacks",
          isPrimary: true,
          title: "כל ההיגדים",
          getDataAsync: this.getAllFeedbacksStatements,
          perPage: 100,
          fields,
          filters: null,
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: false,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש מהיר",
          },
          sideViewEntity,
        },
      ];
    },
    addLecturesFeedbackStatement() {
      Modal.open({
        component: DialogAddLecturesFeedbackStatement,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllFeedbacksStatements({ ...rest }) {
      return CoursesService.getCourseFeedbacksStatements(this.course.id, rest).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
  },
};
</script>
<style scoped lang="scss">
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}
</style>
